import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback as O, useRef as u, useState as R } from "react";

function p() {
  var i = new Map();

  function l(_ref) {
    var s = _ref.root,
        t = _ref.rootMargin,
        c = _ref.threshold;
    var r = i.get(s);
    r || (r = new Map(), i.set(s, r));
    var v = JSON.stringify({
      rootMargin: t,
      threshold: c
    }),
        o = r.get(v);

    if (!o) {
      var e = new Map();
      o = {
        observer: new IntersectionObserver(function (y) {
          y.forEach(function (k) {
            var _e$get;

            (_e$get = e.get(k.target)) === null || _e$get === void 0 ? void 0 : _e$get(k);
          });
        }, {
          root: s,
          rootMargin: t,
          threshold: c
        }),
        entryCallbacks: e
      }, r.set(v, o);
    }

    return {
      observe: function observe(e, b) {
        o.entryCallbacks.set(e, b), o.observer.observe(e);
      },
      unobserve: function unobserve(e) {
        o.entryCallbacks.delete(e), o.observer.unobserve(e);
      }
    };
  }

  return {
    getObserver: l
  };
}

var C = "0px",
    d = [0],
    H = p();

function E(i) {
  var _i$rootMargin, _i$threshold;

  var l = (_i$rootMargin = i === null || i === void 0 ? void 0 : i.rootMargin) !== null && _i$rootMargin !== void 0 ? _i$rootMargin : C,
      s = (_i$threshold = i === null || i === void 0 ? void 0 : i.threshold) !== null && _i$threshold !== void 0 ? _i$threshold : d,
      t = u(null),
      c = u(null),
      r = u(null),
      _R = R(),
      _R2 = _slicedToArray(_R, 2),
      v = _R2[0],
      o = _R2[1],
      e = O(function () {
    var n = t.current;

    if (!n) {
      o(void 0);
      return;
    }

    var a = H.getObserver({
      root: c.current,
      rootMargin: l,
      threshold: s
    });
    a.observe(n, function (f) {
      o(f);
    }), r.current = a;
  }, [l, s]),
      b = O(function () {
    var n = r.current,
        a = t.current;
    a && n !== null && n !== void 0 && n.unobserve(a), r.current = null;
  }, []),
      y = O(function (n) {
    b(), t.current = n, e();
  }, [e, b]),
      k = O(function (n) {
    b(), c.current = n, e();
  }, [e, b]);

  return [y, {
    entry: v,
    rootRef: k
  }];
}

var I = E;
import { useState as m } from "react";

function h(i) {
  var _s$entry;

  var _I = I(i),
      _I2 = _slicedToArray(_I, 2),
      l = _I2[0],
      s = _I2[1],
      t = !!((_s$entry = s.entry) !== null && _s$entry !== void 0 && _s$entry.isIntersecting),
      _m = m(t),
      _m2 = _slicedToArray(_m, 2),
      c = _m2[0],
      r = _m2[1];

  return t && !c && r(!0), [l, _objectSpread(_objectSpread({}, s), {}, {
    isVisible: t,
    wasEverVisible: c
  })];
}

var g = h;
export { I as useIntersectionObserver, g as useTrackVisibility };